import React from 'react';
import { Route, Redirect } from 'react-router';

import Main from "./components/Main";
import Auth from "./components/Auth";
import Wrapper from "./components/Wrapper";
import Callbacks from './containers/Callbacks';
import Orders from './containers/Orders';
import Services from './containers/Services';
import Customers from './containers/Customers';
import Settings from './containers/Settings';
import Analytics from './containers/Analytics';
import {
    UrgentTab,
    DeliveryTab,
    DeliveryReceivingPointTab,
    DoneTab,
    AllTab,
    ProcessedTab,
    InProcessTab,
    OnIntermediatePointTab,
    OnReceivingPoint,
    ReceptionPointProcessed,
    ReceptionPointOrders
} from './components/orders/Tabs';

const PrivateRouteWrapper = ({ component: Component, showHeader, ...rest }) => {
    const render = props => {
        return sessionStorage.getItem('man-token') ?
            (<Wrapper {...props} component={Component} showHeader={showHeader} />) :
            (<Redirect to={{ pathname: '/login', state: { from: props.location } }} />);
    }
    return <Route {...rest} render={render} />;
};

const routes = () => {
    return (<div>
        <PrivateRouteWrapper exact path="/" component={Main} />
        <Route exact path="/login" component={Auth} />
        <PrivateRouteWrapper path="/callbacks" component={Callbacks} />
        <PrivateRouteWrapper path="/reception-point-callbacks" component={Main} />
        <PrivateRouteWrapper path="/orders" component={Orders} />
        <PrivateRouteWrapper path="/services" component={Services} />
        <PrivateRouteWrapper path="/customers" component={Customers} />
        <PrivateRouteWrapper path="/settings" component={Settings} />
        <PrivateRouteWrapper path="/analytics" component={Analytics} />
        <PrivateRouteWrapper exact path="/orders/urgent" component={UrgentTab} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/delivery" component={DeliveryTab} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/reception-point-delivery" component={DeliveryReceivingPointTab} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/done" component={DoneTab} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/compleated" component={DoneTab} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/all" component={AllTab} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/all-on-points" component={AllTab} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/reception-point-processed" component={ReceptionPointProcessed} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/processed" component={ProcessedTab} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/on-factory" component={InProcessTab} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/on-intermediate-point" component={OnIntermediatePointTab} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/on-receiving-point" component={OnReceivingPoint} showHeader={false} />
        <PrivateRouteWrapper exact path="/orders/reception-point-orders" component={ReceptionPointOrders} showHeader={false} />
    </div>);
}

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js